import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { v4 as uuid } from "uuid"
import _ from "lodash"
import { Tooltip } from "primereact/tooltip";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";

import './index.css'

import SellerSearch from "../../common/SellerSearch";
import Loading from "../../common/Loading";
import CopyToClipboard from "../../common/CopyToClipboard";

import ProductComponent from "./Components/ProductComponent";
import VendorComponent from "./Components/VendorComponent";

import { fetchCompanyBusinessTypes, fetchCompanyCreditPeriods, fetchCompanyWarehouses, fetchHSNMasterData, fetchMaterialBrands, fetchMaterialCategories, fetchPMBranches, fetchStates } from "../../services/redux/reducers/commonThunk";
import { getBuyerCompanyAndUserDetailsByBuyerReqId, getBuyerRequirementsById } from "../../services/api/buyerReq";
import { postBulkSellerReq, getSellerReqByBuyerReqId, expireSellerReqItem, postSellerReq, getSellersByUserIds, getSellerSuggestions, getSellersByUserIdsForUseFromStock, getHSNSuggestions } from "../../services/api/sellerReq";
import { insertSellerReqItem } from "../../services/api/sellerReqItem";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { isUserVerified } from "../../services/api/auth";
import { getMaterialMasterAndTempMaterialIds } from "../../services/api/materialMaster";
import { getStockWarehouseByMaterialIds } from "../../services/api/stockWarehouse";
import { searchMaterialMandatoryUseFromStock } from "../../services/api/materialMandatoryUseFromStock";
import { getVendorRateContractItemsByIds } from "../../services/api/vendorRateContractItem";
import { getPastSellerPOMaterialTransactions } from "../../services/api/sellerPO";

import { calculateStockGSTAndPrice, getFullName, round, sortArrayOfObjectsInAlphabeticalOrder } from "../../utils";
import { Button , DropDownField, TextInputField  } from "../../helpers";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { smartStockMovesParser, stockWarehousesParser } from "../../parserFunctions";
import SellerRequisitionSkeleton from "../../skeletons/SellerRequisitionSkeleton";


function SendRequisition() {
    const { buyerReqId } = useParams()

    const [visibleAssignSeller, setVisibleAssignSeller] = useState(false)
    const [isRecommendedSellersNeeded, setIsRecommendedSellersNeeded] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isInitialLoading, setIsInitialLoading] = useState(false)

    const [selectedItemId, setSelectedItemId] = useState(null)
    const [buyerReqItems, setBuyerReqItems] = useState([])
    const [buyerReq, setBuyerReq] = useState({})
    const [buyerDetails, setBuyerDetails] = useState({})
   
    const [materialDetails, setMaterialDetails] = useState([])
    const [sellerReqs, setSellerReqs] = useState([])
    const [sellerReqItems, setSellerReqItems] = useState([])
    const [sellerPOItems, setSellerPOItems] = useState([])
    const [stockWarehouses, setStockWarehouses] = useState([])
    const [initialSellerReqs, setInitialSellerReqs] = useState([])
    const [initialSellerReqItems, setInitialSellerReqItems] = useState([])
    const [sellerDetails, setSellerDetails] = useState([])
    const [selectedBuyerReqItems, setSelectedBuyerReqItems] = useState([])
    const [selectedSellerReqs, setSelectedSellerReqs] = useState([])
    const [deliveryAddressList, setDeliveryAddressList] = useState([])
    const [editableSellerReqIds, setEditableSellerReqIds] = useState([])
    const [materialMandatoryUseFromStock, setMaterialMandatoryUseFromStock] = useState([])
    const [vendorRateContractItems, setVendorRateContractItems] = useState([])
    const [pastSellerPOMaterialTransactions, setPastSellerPOMaterialTransactions] = useState([])
    const [isPrevSelPOMaterialTransactionsLoading, setIsPrevSelPOMaterialTransactionsLoading] = useState(false)
    const [isSellerRecomendationsLoading, setIsSellerRecomendationsLoading] = useState(false)
    const [sellerSuggestions, setSellerSuggestions] = useState([])
    const [allSellerSuggestions, setAllSellerSuggestions] = useState([])
    const [buyerBranchUsers, setBuyerBranchUsers] = useState([])
    const [hsnSuggestions, setHSNSuggestions] = useState([])

    const [isStarRFQ, setIsStartRFQ] = useState(false)
    const [hasNullDocProof, setHasNullDocProof] = useState(false)
    const [globalLeadTime, setGlobalLeadTime] = useState(null)
    const [globalGSTRate, setGlobalGSTRate] = useState(null)
    const [globalHSNCode, setGlobalHSNCode] = useState(null)
    const [selectAll, setSelectAll] = useState(false)

    const dispatch = useDispatch()

    const usersData = useSelector(state => state.userDetails)
    const companyBranches = usersData.PMCompanyDetails.companyBranches
    const materialBrandsData = useSelector(state => state.common.materialBrands)
    const materialCategoriesData = useSelector(state => state.common.materialCategories)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const companyBusinessTypes = useSelector(state => state.common.companyBusinessTypes)
    const companyWarehousesData = useSelector(state => state.common.companyWarehouses)
    const states= useSelector(state => state.common.states)
    const PMBranches = useSelector(state => state.common.PMBranches)
    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)

    const deliveryAddressData = usersData.PMCompanyDetails.companyBranchShipAddrs

    const PMCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)

    let isPassRequirement = false
    if (buyerReq.pmBranchId === 24716) {
        isPassRequirement = true
    }

    useEffect(() => {
        const allActiveSellerReqItems = sellerReqItems.filter(item => item.statusId === 1);
        const totalAmountBeforeTaxForAllActiveItems = allActiveSellerReqItems.reduce((sum, item) => {
            return sum + (item.quotTotalAmountBeforeTax || 0)
        }, 0)
        
        if (totalAmountBeforeTaxForAllActiveItems >= 500000) {
            setIsStartRFQ(true)
        } else {
            setIsStartRFQ(false)
        }
        const sellerReqsWithQuotedItems = sellerReqs.filter(sellerReq => 
            sellerReqItems.some(item => item.sellerReqId === sellerReq.sellerReqId && item.quotTotalAmountWithTax > 0)
        )
    
        const hasNullDocProof = sellerReqsWithQuotedItems.some(sellerReq => 
            sellerReq.docProof === null || 
            (Array.isArray(sellerReq.docProof) && sellerReq.docProof.length === 0)
        )
        setHasNullDocProof(hasNullDocProof)
        
    }, [sellerReqItems])
   
    useEffect(()=> {
        dispatch(fetchHSNMasterData())
        dispatch(fetchCompanyBusinessTypes())
        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchStates())
        dispatch(fetchCompanyWarehouses())
        dispatch(fetchPMBranches())
        dispatch(fetchCompanyCreditPeriods())
    },[usersData])

    useEffect(()=> {
        if (companyWarehousesData?.length > 0){
            getBuyerRequirements()
        }
    },[companyWarehousesData, materialBrandsData, materialCategoriesData])

    // useEffect(() => {
    //     getStockWarehouses()
    // }, [buyerReqItems])

    useEffect(() => {
        const editableSellerReqIds = sellerReqs
            .filter(each => each?.disabled !== true)
            .map(each => each?.sellerReqId)
        
        setEditableSellerReqIds(editableSellerReqIds)
    
        const updatedSelectedSellerReqs = selectedSellerReqs.filter(reqId =>
            editableSellerReqIds.includes(reqId)
        )
        setSelectedSellerReqs(updatedSelectedSellerReqs)
    }, [sellerReqs])

    useEffect(() => {
        if (selectedSellerReqs.length === sellerReqs.length) {
            setSelectAll(true)
        } else {
            setSelectAll(false)
        }
    }, [selectedSellerReqs, sellerReqs.length])
    
    const getBuyerRequirements = async ()=> {
        setIsInitialLoading(true)
        const response = await getBuyerRequirementsById(buyerReqId)
        if (response.failure){
            dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Buyer Requirements not fetched', life: 3000}))
        } else {
            const buyerReq = response.data.buyerRequirement
            let shippingAddress = response.data.shippingAddress
            shippingAddress.warehouseName = "Send to Client"
            let buyerReqItems = []
            let delAddr = companyWarehousesData?.find(eachCompanyWarehouse => eachCompanyWarehouse?.warehouseId === buyerReq?.pmWarehouseId)
            let delAddrId = delAddr?.shipAddrId ? delAddr.shipAddrId : shippingAddress?.shipAddrId
           
            let sortedDeliveryAddress = sortArrayOfObjectsInAlphabeticalOrder(companyWarehousesData, "warehouseName")
            sortedDeliveryAddress = sortedDeliveryAddress?.map(eachDeliveryAddr => ({...eachDeliveryAddr, ...eachDeliveryAddr?.companyBranchShipAddrs}))

            let materialIds = []
            buyerReq.buyerReqItems.map(eachReqItem => {
                let buyerReqItem = {}
                materialIds.push(eachReqItem?.materialId)
                buyerReqItem = {id : uuid(), ...eachReqItem, delAddrId: delAddrId}
                buyerReqItems.push(buyerReqItem)
            })
            let data ={ materialIds : materialIds }

            const materialDetailsResponse = await getMaterialMasterAndTempMaterialIds(data)
            if (materialDetailsResponse?.failure){
                dispatch(raiseToast({severity:'error', detail: materialDetailsResponse.data.error, summary:'Material Details Not Fetched', life: 3000}))
            }else {
                const updatedMaterialDetails = materialDetailsResponse?.data?.map(eachMaterial => {
                    const relatedBrand = materialBrandsData?.find(eachBrand => eachBrand?.brandId === eachMaterial?.brandId)
                    const relatedCategory = materialCategoriesData?.find(eachCategory => eachCategory?.categoryId === eachMaterial?.categoryId)
                    return {...eachMaterial, ...relatedBrand, ...relatedCategory}
                })
                setMaterialDetails(updatedMaterialDetails)
            }

            const buyerCompanyRes = await getBuyerCompanyAndUserDetailsByBuyerReqId({ buyerReqId: buyerReq.buyerReqId, isPassRequirement: buyerReq.pmBranchId === 24716 })
            if (buyerCompanyRes?.failure){
                dispatch(raiseToast({severity:'error', detail: buyerCompanyRes.data.error, summary:'Buyer Company', life: 3000}))
            }else {
                let userName = buyerCompanyRes?.data?.firstName + " " + buyerCompanyRes?.data?.lastName
                let details = {...buyerCompanyRes?.data, userName}
                setBuyerBranchUsers(buyerCompanyRes.data.buyerBranchUsers)
                setBuyerDetails(details)
            }

            setBuyerReq(buyerReq)
            setBuyerReqItems(buyerReqItems)
            setDeliveryAddressList([shippingAddress,...sortedDeliveryAddress])
            const updatedStockWarehouses = await getStockWarehouses(buyerReqItems)
            await getSellerReq(buyerReqItems, buyerReq, updatedStockWarehouses)
        }
    }

    const getSellerReq = async (buyerReqItems, buyerReq, updatedStockWarehouses) => {
        setIsInitialLoading(true)
        let userResponse = []

        const response = await getSellerReqByBuyerReqId(buyerReqId)
        if (response.failure){
            dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Seller Req not fetched'}))
        } else {
            let sellerReqItems = []
            if(response.sellerReqs){
                let sellerReqIds = []
                let userIds = []
                let useFromStockUserIds = []

                response.sellerReqs.map(eachSellerReq => {
                    if (eachSellerReq.companyId === eachSellerReq.pmCompanyId){
                        useFromStockUserIds.push(eachSellerReq.userId)
                    }else{
                        userIds.push(eachSellerReq.userId)
                    }
                })

                let data = {
                    userIds : userIds
                }
                let userRes = await getSellersByUserIds(data)
                if (userRes?.failure){
                    dispatch(raiseToast({severity:'error', detail: userRes.data.error, summary:'Sellers not fetched', life: 3000}))
                }
                if (userRes){
                    userResponse = [...userRes]
                }

                let userResponseForUseStockRes = await getSellersByUserIdsForUseFromStock({userIds: useFromStockUserIds})
                if (userResponseForUseStockRes?.failure){
                    dispatch(raiseToast({severity:'error', detail: userResponseForUseStockRes.data.error, summary:'Sellers from use stock not fetched', life: 3000}))
                }
                
                if (userResponseForUseStockRes){
                    let sellerReqUsers = userResponseForUseStockRes?.map(eachUser => {
                        const relatedSellerReq = response?.sellerReqs?.find(eachSellerReq => eachSellerReq?.userId === eachUser?.userId)
                        const relatedBranch = companyBranches?.find(eachCompanyBranch => eachCompanyBranch?.branchId === relatedSellerReq?.branchId)
                        return {...eachUser, ...relatedBranch}
                    })
                    userResponse = [...userResponse, ...sellerReqUsers]
                }

                let updatedBuyerReqItems = []
                sellerReqItems = response?.sellerReqItems?.map(eachSellerReqItem => {
                    const relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachSellerReqItem.buyerReqItemId)
                    if (relatedBuyerReqItem){
                        relatedBuyerReqItem.delAddrId = eachSellerReqItem.shipAddrId
                    }
                    eachSellerReqItem.isEditable = false
                    sellerReqIds.push(eachSellerReqItem.sellerReqId)
                    if (eachSellerReqItem.quotLogisticsBeforeTax ){
                        return { ...eachSellerReqItem, showLogistics : true }
                    } else {
                        return { ...eachSellerReqItem }
                    }
                })

                let sellerReqs = response.sellerReqs.filter(eachSellerReq => sellerReqIds.includes(eachSellerReq.sellerReqId))
                sellerReqs = sellerReqs.map(eachSellerReq => ({...eachSellerReq, disabled: true}))
                let updatedSellerReqs = _.sortBy(sellerReqs, "sellerReqId")

                buyerReqItems.map(eachBuyerReqItem => {
                    let relatedSellerReqItem = sellerReqItems.find(eachSellerReqItem => eachSellerReqItem?.buyerReqItemId === eachBuyerReqItem?.buyerReqItemId)
                    if (relatedSellerReqItem?.sellerReqId && !relatedSellerReqItem?.isNew){
                        eachBuyerReqItem.delAddrId = relatedSellerReqItem.shipAddrId
                        updatedBuyerReqItems.push(eachBuyerReqItem)
                    }else{
                        updatedBuyerReqItems.push(eachBuyerReqItem)
                    }
                })

                const vendorRateContractItemIds = []
                sellerReqItems.map(eachSellerReqItem => {
                    if(eachSellerReqItem.vendorRateContractItemId){
                        vendorRateContractItemIds.push(eachSellerReqItem.vendorRateContractItemId)
                    }
                })

                if(vendorRateContractItemIds.length){
                    const vendorRateContractItemRes = await getVendorRateContractItemsByIds({vendorRateContractItemIds})
                    if (vendorRateContractItemRes.failure){
                        return dispatch(raiseToast({severity:'error', detail: vendorRateContractItemRes.data.error, summary:'Vendor Rate Contracts'}))
                    }

                    if(vendorRateContractItemRes.data?.length){
                        dispatch(raiseToast({severity:'info', detail: `Some seller requirements are automatically included due to the vendor's rate contract.`}))
                    }
                    setVendorRateContractItems(vendorRateContractItemRes.data)
                }

                setBuyerReqItems(updatedBuyerReqItems)
                setSellerReqs(updatedSellerReqs)
                setSellerReqItems(sellerReqItems)
                setSellerPOItems(response?.sellerPOItems)
                setInitialSellerReqItems(sellerReqItems)
                setInitialSellerReqs(sellerReqs)
            }

            const sellers = userResponse.map(eachSeller => {
                let name = ""
                if (eachSeller.companyId !== eachSeller.pmCompanyId){
                    if (eachSeller.firstName){
                        name = eachSeller?.firstName + " "
                    }
                    if (eachSeller.lastName){
                        name += eachSeller?.lastName
                    }
                    eachSeller.name = name
                }else{
                    const relatedWarehouse = companyWarehousesData?.find(eachCompanyWarehouse => eachCompanyWarehouse?.warehouseManagerId === eachSeller?.userId)
                    let relatedWarehouseName = ""
                    if (relatedWarehouse?.warehouseName){
                        relatedWarehouseName = `- ${relatedWarehouse?.warehouseName}`
                    }
                    name = `Warehouse ${relatedWarehouseName}`
                    eachSeller.name = name
                }
                const relatedState = states?.find(eachState => eachState?.stateId === eachSeller?.stateId)
                return {...eachSeller, stateName : relatedState?.stateName}
            })
            const filteredSellers = []
            response.sellerReqs?.map(eachSellerReq => {
                let relatedSeller = sellers?.find(eachSeller => eachSeller.userId === eachSellerReq.userId && eachSeller.companyId === eachSellerReq.companyId && eachSeller.branchId === eachSellerReq.branchId)
                if(relatedSeller){
                    filteredSellers.push(relatedSeller)
                }
            })
            setSellerDetails(filteredSellers)
        }
        setIsInitialLoading(false)

        let materialIdAndWarehouseIdCombinations = buyerReqItems.map(eachBuyerReqItem => {
            if (sellerReqItems.length) {
                const relatedSellerReqItem = sellerReqItems.find(eachSellerReqItem => eachBuyerReqItem.materialId === eachSellerReqItem.materialId)
                if (relatedSellerReqItem) {
                    const relatedCompanyWarehouse = companyWarehousesData.find(eachCompanyWarehouse => eachCompanyWarehouse.shipAddrId === relatedSellerReqItem.shipAddrId)
                    if (relatedCompanyWarehouse) {
                        return {
                            materialId: eachBuyerReqItem.materialId,
                            warehouseId: relatedCompanyWarehouse.warehouseId
                        }
                    }
                }
            }
            return {
                materialId: eachBuyerReqItem.materialId,
                warehouseId: buyerReq.pmWarehouseId
            }
        })

        const relatedMaterials = buyerReqItems.map(eachReqItem => eachReqItem.materialId)

        setIsPrevSelPOMaterialTransactionsLoading(true)
        const pastSellerPOMaterialtransactiosRes = await getPastSellerPOMaterialTransactions({ materialIdAndWarehouseIdCombinations, pmBranchId: buyerReq.pmBranchId })
        if (pastSellerPOMaterialtransactiosRes.failure) {
            setIsPrevSelPOMaterialTransactionsLoading(false)
            dispatch(raiseToast({ severity: 'error', summary: 'Past Seller PO Material Transactions', detail: pastSellerPOMaterialtransactiosRes.data.error }))
        }
        setPastSellerPOMaterialTransactions(pastSellerPOMaterialtransactiosRes.data)
        setIsPrevSelPOMaterialTransactionsLoading(false)

        setIsSellerRecomendationsLoading(true)
        
        const sellerSuggestionsRes = await getSellerSuggestions({ materialIds: relatedMaterials, pmBranchId: buyerReq.pmBranchId })
        if (sellerSuggestionsRes.failure) {
            setIsSellerRecomendationsLoading(false)
            dispatch(raiseToast({ severity: 'error', summary: 'Seller Suggestions', detail: sellerSuggestionsRes.data.error }))
        }

        if (sellerSuggestionsRes.data.length) {
            let updatedSellerSuggestions = sellerSuggestionsRes.data.filter(eachSelSugg => eachSelSugg.companyId !== eachSelSugg.pmCompanyId)

            if(buyerReq.orderTypeId !== 3){
                updatedStockWarehouses.forEach(eachStockWarehouse => {
                    const newUseStockSellerSugg = {
                        materialId: eachStockWarehouse.materialId,
                        companyId: eachStockWarehouse.companyId, 
                        pmCompanyId: usersData.PMCompanyDetails.companyId, 
                        pmBranchId: null,
                        unitPrice: eachStockWarehouse.unitPrice,
                        qty: eachStockWarehouse.smartStock,
                        leadTime: null, 
                        createdAt: null,
                        materialpriority: 1,
                        materialRowRank: 1,
                        originalMaterialId: eachStockWarehouse.materialId, 
                        brandId: null,
                        categoryId: null, 
                        productName: null,
                        productSpecification: null,
                        warehouseId: eachStockWarehouse.warehouseId,
                        warehouseName: eachStockWarehouse.warehouseName,
                        companyName: eachStockWarehouse.companyName,
                        companyPaymentTerms: eachStockWarehouse.companyPaymentTerms, 
                        city: eachStockWarehouse.city,
                        businessTypeId: eachStockWarehouse.businessTypeId,
                        gstinCode: eachStockWarehouse.gstinCode,
                        panCode: eachStockWarehouse.panCode,
                        tdsSection194q: eachStockWarehouse.tdsSection194q,
                        userId: eachStockWarehouse.warehouseManagerId,
                        firstName: eachStockWarehouse.firstName,
                        lastName: eachStockWarehouse.lastName,
                        emailId: eachStockWarehouse.emailId,
                        companyId: eachStockWarehouse.companyId,
                        branchId: eachStockWarehouse.branchId,
                        branchName: eachStockWarehouse.branchName,
                        branchPaymentTerms: eachStockWarehouse.branchPaymentTerms,
                        primaryShipAddrId: eachStockWarehouse.primaryShipAddrId,
                        shipAddr: eachStockWarehouse.shipAddr,
                        stateId: eachStockWarehouse.stateId //Which state?
                    }
    
                    updatedSellerSuggestions.push(newUseStockSellerSugg)
                })
            }

            setAllSellerSuggestions(updatedSellerSuggestions)
        }
        else {
            setAllSellerSuggestions(sellerSuggestionsRes.data)
        }

        setIsSellerRecomendationsLoading(false)

        const hsnSuggestionsRes = await getHSNSuggestions({ materialIds: relatedMaterials })
        if (hsnSuggestionsRes.failure) {
            dispatch(raiseToast({ severity: 'error', summary: 'HSN Suggestions', detail: hsnSuggestionsRes.data.error }))
        }
        else {
            setHSNSuggestions(hsnSuggestionsRes.data)
        }
    }

    const getStockWarehouses = async (buyerReqItems) => {
        const materialIds = buyerReqItems?.map(eachBuyerReqItem => eachBuyerReqItem?.materialId)
        const stockWarehouseRes = await getStockWarehouseByMaterialIds({materialIds: materialIds, getWarehouseDetails: true})
        if (stockWarehouseRes?.failure){
            return dispatch(raiseToast({severity:'error', detail: stockWarehouseRes.data.error, summary:'Stock Warehouses not fetched', life: 3000}))
        }

        let updatedStockWarehouses = stockWarehousesParser(stockWarehouseRes?.data)
        updatedStockWarehouses = updatedStockWarehouses.map(eachStockWarehouse => {
            let newSmartStockMoves = []
            if(eachStockWarehouse?.smartStockMoves){
                newSmartStockMoves = smartStockMovesParser(eachStockWarehouse.smartStockMoves)
                eachStockWarehouse.smartStockMoves = newSmartStockMoves
            }

            return eachStockWarehouse
        })

        setStockWarehouses(updatedStockWarehouses) 

        const materialMandatoryUseFromStockRes = await searchMaterialMandatoryUseFromStock({materialIds, paginator: false})
        if(materialMandatoryUseFromStockRes.failure){
            return dispatch(raiseToast({severity:'error', summary:'Mandatory material use from stock',  detail: materialMandatoryUseFromStockRes.data.error, life: 3000}))
        }

        setMaterialMandatoryUseFromStock(materialMandatoryUseFromStockRes.data.data)

        return updatedStockWarehouses
    }

    const handleExpiryClick = async (type, sellerReqItem, sellerReq) => {
        if (sellerReq.companyId === sellerReq.pmCompanyId){
            setIsLoading(true)

            if (sellerReqItem?.isNew){ //??
                dispatch(raiseToast({severity:'warn', detail:'Seller Req Item cannot be Marked as Expired.', life: 3000}))
            }
            else{
                const relatedStockMaterial = stockWarehouses.find(eachStockWarehouse => eachStockWarehouse.materialId === sellerReqItem.materialId)

                if (relatedStockMaterial && relatedStockMaterial.smartStock > 0) {
                    const isActiveSellerPOItem = sellerPOItems?.find(eachSellerPOItem => eachSellerPOItem?.sellerReqItemId === sellerReqItem?.sellerReqItemId && eachSellerPOItem?.statusId === 1)
                    if(false){ //(isActiveSellerPOItem?.sellerPOItemId){
                        dispatch(raiseToast({severity:'error', detail:`Please cancel the PO number: ${isActiveSellerPOItem?.docNo}, before marking this expired`, life: 3000}))
                    }else{
                        if (window.confirm("Do you want to Expire the quotation?")){
                            const response = await expireSellerReqItem(sellerReqItem.sellerReqItemId)
                            if(response.failure){
                                return dispatch(raiseToast({severity:'success', summary: 'expire seller req item', detail: response.data.error, life: 3000}))
                            }

                            const activeRoleId = usersData?.activeRoleId
                            const relatedUserBranch = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
                            
                            let quotQty = relatedStockMaterial?.smartStock > sellerReqItem?.qty ? sellerReqItem?.qty : relatedStockMaterial?.smartStock
                            const { unitPrice, GSTRate } = calculateStockGSTAndPrice(quotQty, relatedStockMaterial.smartStockMoves)
                            let quotTotalAmountBeforeTax = parseFloat(quotQty) * unitPrice
                            let totalTax = parseFloat(quotTotalAmountBeforeTax * GSTRate * 0.01)
                            let quotTotalAmountWithTax = quotTotalAmountBeforeTax + totalTax

                            const relatedHSNSuggestion = hsnSuggestions.find(eachHSNSuggestion => eachHSNSuggestion.originalMaterialId === sellerReqItem.materialId)

                            const newSellerReqItem = {
                                // sellerReqItemId: uuid(),
                                sellerReqId: sellerReqItem.sellerReqId,
                                buyerReqId : parseInt(sellerReqItem.buyerReqId),
                                buyerReqItemId: sellerReqItem.buyerReqItemId,
                                materialId: sellerReqItem.materialId,
                                docNo: sellerReq.docNo,
                                fileNo: sellerReq.fileNo,
                                shipAddrId : sellerReqItem.shipAddrId,
                                showLogistics: false,
                                qty : sellerReqItem.qty,
                                statusId: 1,
                                quotQty: quotQty,
                                quotListPrice: unitPrice,
                                quotDiscountRate: 0,
                                quotUnitPrice: unitPrice,
                                quotHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                                quotTotalAmountBeforeTax: quotTotalAmountBeforeTax,
                                quotGSTRate: GSTRate,
                                quotTotalAmountWithTax: quotTotalAmountWithTax,
                                quotLeadTime: 0,
                                quotLogisticsBeforeTax: 0,
                                quotLogisticsGSTRate: 0,
                                quotLogisticsWithTax: 0,
                                isNew: true,
                                createdBy: usersData?.userId, 
                                pmCompanyId: relatedUserBranch?.pmCompanyId,
                                updatedBy: usersData?.userId,
                                isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true,
                                suggestedHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                            }
                            if (response.failure){
                                dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Seller Req not marked as expired', life: 3000}))
                            }else{
                                const newSellerReqItemRes = await insertSellerReqItem(newSellerReqItem)
                                if(newSellerReqItemRes.failure){
                                    return dispatch(raiseToast({severity:'success', summary: 'insert seller req item', detail: newSellerReqItemRes.data.error, life: 3000}))
                                }

                                let updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                                    if (eachSellerReqItem?.sellerReqItemId === sellerReqItem?.sellerReqItemId){
                                        return {...eachSellerReqItem, statusId : 2, canEditExpiredAndLogistics: false, isEditable: false}
                                    }else{
                                        return eachSellerReqItem
                                    }
                                })
                                updatedSellerReqItems = [...updatedSellerReqItems, {...newSellerReqItemRes, canEditExpiredAndLogistics: true, isEditable: true}]
                                
                                setSellerReqItems(updatedSellerReqItems) 
                                setInitialSellerReqItems(updatedSellerReqItems)

                                dispatch(raiseToast({severity:'success', detail:'Seller Req Item marked as expired and You can re-enter the quotation', life: 3000}))
                            }
                        }else{
                            const updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                                if (eachSellerReqItem?.sellerReqId === sellerReq?.sellerReqId){
                                return {...eachSellerReqItem, canEditExpiredAndLogistics: true}
                                }
                                return eachSellerReqItem
                            })
                            setSellerReqItems(updatedSellerReqItems)
                            setInitialSellerReqItems(updatedSellerReqItems)
                        }
                    }
                }else{
                    dispatch(raiseToast({severity:'warn', detail:'Seller Req Item cannot be Marked as Expired. As Stock is Not available for this at this time.', life: 3000}))
                }
            }
            setIsLoading(false)
        }
        else{
            setIsLoading(true)

            if (sellerReqItem?.isNew){
                dispatch(raiseToast({severity:'warn', detail:'Seller Req Item cannot be Marked as Expired.', life: 3000}))
            }
            else{
                const isActiveSellerPOItem = sellerPOItems?.find(eachSellerPOItem => eachSellerPOItem?.sellerReqItemId === sellerReqItem?.sellerReqItemId && eachSellerPOItem?.statusId === 1)
                if (type === "expiry"){
                    if(false){ //(isActiveSellerPOItem?.sellerPOItemId){
                        dispatch(raiseToast({severity:'error', detail:`Please cancel the PO number: ${isActiveSellerPOItem?.docNo}, before marking this expired`, life: 3000}))
                    }else{
                        if (window.confirm("Do you want to expire the SellerReqItem?")){
                            const response = await expireSellerReqItem(sellerReqItem.sellerReqItemId)
                            if (response.failure){
                                dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Seller Req not marked as expired', life: 3000}))
                            }else{
                                dispatch(raiseToast({severity:'success', detail:'Seller Req Item marked as expired', life: 3000}))

                                const relatedHSNSuggestion = hsnSuggestions.find(eachHSNSuggestion => eachHSNSuggestion.originalMaterialId === sellerReqItem.materialId)

                                let HSNCode = sellerReqItem.quotHSNCode
                                if (relatedHSNSuggestion){
                                    HSNCode = relatedHSNSuggestion.HSNCode
                                }

                                const newSellerReqItem = {
                                    sellerReqItemId: uuid(),
                                    sellerReqId: sellerReqItem.sellerReqId,
                                    buyerReqId : parseInt(sellerReqItem.buyerReqId),
                                    buyerReqItemId: sellerReqItem.buyerReqItemId,
                                    materialId: sellerReqItem.materialId,
                                    docNo: sellerReq.docNo,
                                    fileNo: sellerReq.fileNo,
                                    shipAddrId : sellerReqItem.shipAddrId,
                                    showLogistics: false,
                                    statusId: 1,
                                    quotQty: 0,
                                    quotListPrice: 0,
                                    quotDiscountRate: 0,
                                    quotUnitPrice: 0,
                                    quotHSNCode: PMCompanyConfig.HSNEntryAllowed ? HSNCode : PMCompanyConfig.defaultHSNCode,
                                    quotTotalAmountBeforeTax: 0,
                                    quotGSTRate: null,
                                    quotTotalAmountWithTax: 0,
                                    quotLeadTime: 0,
                                    quotLogisticsBeforeTax: 0,
                                    quotLogisticsGSTRate: 0,
                                    quotLogisticsWithTax: 0,
                                    isNew: true,
                                    isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? true : false,
                                    isEditable: true,
                                    suggestedHSNCode: relatedHSNSuggestion ? HSNCode : null,
                                }
                                // await getSellerReq()   
                                const updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                                    if (eachSellerReqItem?.sellerReqItemId === sellerReqItem?.sellerReqItemId){
                                        return {...eachSellerReqItem, statusId : 2, isEditable: false, isHSNEditable:  PMCompanyConfig.HSNEntryAllowed ? false : true}
                                    }
                                    return eachSellerReqItem
                                })
                                setSellerReqItems([...updatedSellerReqItems, newSellerReqItem])
                                setInitialSellerReqItems([...updatedSellerReqItems, newSellerReqItem])
                                // setSellerReqItems(prevState => [...prevState, newSellerReqItem]) 
                            }
                        }else{
                            const updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                                if (eachSellerReqItem?.sellerReqId === sellerReq?.sellerReqId){
                                return {...eachSellerReqItem, canEditExpiredAndLogistics: true}
                                }
                                return eachSellerReqItem
                            })
                            setSellerReqItems(updatedSellerReqItems)
                            setInitialSellerReqItems(updatedSellerReqItems)
                        }
                    }
                } else if (type === "refresh") {
                    if(false){ //(isActiveSellerPOItem?.sellerPOItemId){
                        dispatch(raiseToast({severity:'error', detail:`Please cancel the PO number: ${isActiveSellerPOItem?.docNo}, before marking this expired`, life: 3000}))
                    }else{
                        if (window.confirm("Do you want to re-renter the quotation?")){
                            const response = await expireSellerReqItem(sellerReqItem.sellerReqItemId)
                            const activeRoleId = usersData?.activeRoleId
                            const relatedUserBranch = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
                            const relatedHSNSuggestion = hsnSuggestions.find(eachHSNSuggestion => eachHSNSuggestion.originalMaterialId === sellerReqItem.materialId)

                            let HSNCode = sellerReqItem.quotHSNCode
                            if (relatedHSNSuggestion){
                                HSNCode = relatedHSNSuggestion.HSNCode
                            }
                            const newSellerReqItem = {
                                // sellerReqItemId: uuid(),
                                sellerReqId: sellerReqItem.sellerReqId,
                                buyerReqId : parseInt(sellerReqItem.buyerReqId),
                                buyerReqItemId: sellerReqItem.buyerReqItemId,
                                materialId: sellerReqItem.materialId,
                                docNo: sellerReq.docNo,
                                fileNo: sellerReq.fileNo,
                                shipAddrId : sellerReqItem.shipAddrId,
                                showLogistics: false,
                                qty : sellerReqItem.qty,
                                statusId: 1,
                                quotQty: sellerReqItem.quotQty,
                                quotListPrice: sellerReqItem.quotListPrice,
                                quotDiscountRate: 0,
                                quotUnitPrice: 0,
                                quotHSNCode: PMCompanyConfig.HSNEntryAllowed ? HSNCode : PMCompanyConfig.defaultHSNCode,
                                quotTotalAmountBeforeTax: 0,
                                quotGSTRate: sellerReqItem.quotGSTRate,
                                quotTotalAmountWithTax: 0,
                                quotLeadTime: sellerReqItem.quotLeadTime,
                                quotLogisticsBeforeTax: 0,
                                quotLogisticsGSTRate: 0,
                                quotLogisticsWithTax: 0,
                                isNew: true,
                                createdBy : usersData?.userId, 
                                pmCompanyId : relatedUserBranch?.pmCompanyId,
                                updatedBy : usersData?.userId,
                                isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true,
                                suggestedHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null
                            }
                            if (response.failure){
                                dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Seller Req not marked as expired', life: 3000}))
                            }else{
                                const insertResponse = await insertSellerReqItem(newSellerReqItem)
                                if(insertResponse.failure){
                                    dispatch(raiseToast({severity:'error', detail: insertResponse.data.error, life: 3000}))
                                }
                                // // console.log("insett", insertResponse)
                                let updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                                    if (eachSellerReqItem?.sellerReqItemId === sellerReqItem?.sellerReqItemId){
                                        return {...eachSellerReqItem, statusId : 2, canEditExpiredAndLogistics: false, isEditable: false}
                                    }else{
                                        return eachSellerReqItem
                                    }
                                })
                                updatedSellerReqItems = [...updatedSellerReqItems, {...insertResponse, canEditExpiredAndLogistics: true, isEditable: true}]
                                
                                setSellerReqItems(updatedSellerReqItems) 
                                setInitialSellerReqItems(updatedSellerReqItems)
                                dispatch(raiseToast({severity:'success', detail:'Seller Req Item marked as expired and You can re-enter the quotation', life: 3000}))
                            }
                        }else{
                            const updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                                if (eachSellerReqItem?.sellerReqId === sellerReq?.sellerReqId){
                                return {...eachSellerReqItem, canEditExpiredAndLogistics: true}
                                }
                                return eachSellerReqItem
                            })
                            setSellerReqItems(updatedSellerReqItems)
                            setInitialSellerReqItems(updatedSellerReqItems)
                        }
                    }
                }
            }
            setIsLoading(false)
        }
    }

    const handleDeliveryAddressChange = (e, buyerReqItemId) => {
        const updatedBuyerReqItems = buyerReqItems.map(eachBuyerReqItem => {
            if (eachBuyerReqItem.buyerReqItemId === buyerReqItemId){
                let newBuyerReqItem = {...eachBuyerReqItem, delAddrId : e.value}
                return newBuyerReqItem
            } else {
                return eachBuyerReqItem
            }
        })

        const updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
            if (eachSellerReqItem.buyerReqItemId === buyerReqItemId){
                let newSellerReqItem = {...eachSellerReqItem, shipAddrId : e.value}
                return newSellerReqItem
            } else {
                return eachSellerReqItem
            }
        })
        setSellerReqItems(updatedSellerReqItems)
        setBuyerReqItems(updatedBuyerReqItems)
    }

    const handleBulkSendMail = async() => { 
        setIsLoading(true)
        const updatedSellerReqs = sellerReqs.filter(eachSellerReq => selectedSellerReqs.includes(eachSellerReq.sellerReqId))
        if (!updatedSellerReqs.length > 0){
            dispatch(raiseToast({severity:'error', detail:'Select the Sellers', life: 3000}))
        }else {
            const relatedSellerReqItems = sellerReqItems.filter(eachSellerReqItem => selectedSellerReqs.includes(eachSellerReqItem.sellerReqId))
            const activeRoleId = usersData?.activeRoleId
            const relatedUserBranch = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
    
            const updatedSellerReqItems = relatedSellerReqItems.map(eachSellerReqItem => {
                let relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachSellerReqItem.buyerReqItemId)
                return {...eachSellerReqItem, qty : relatedBuyerReqItem.qty, pmCompanyId: relatedUserBranch?.pmCompanyId, createdBy : usersData?.userId, updatedBy : usersData?.userId}
            })
            
            const updatedSellerReqData = updatedSellerReqs?.map(eachSellerReq => {
                const relatedSeller = sellerDetails?.find(eachSeller => eachSeller?.userId === eachSellerReq?.userId) 
                const isURD = relatedSeller?.gstinCode ? false : true
                if (relatedSeller.branchPaymentTerms){
                    eachSellerReq.paymentTerms = relatedSeller.branchPaymentTerms
                }else {
                    eachSellerReq.paymentTerms = relatedSeller.companyPaymentTerms
                }
                return {
                    branchId : eachSellerReq?.branchId,
                    buyerReqId : parseInt(eachSellerReq?.buyerReqId),
                    companyId : eachSellerReq?.companyId,
                    userId: eachSellerReq?.userId,
                    isNew : eachSellerReq?.isNew,
                    sellerReqId: eachSellerReq?.sellerReqId,
                    paymentTerms: eachSellerReq?.paymentTerms,
                    pmCompanyId: relatedUserBranch?.pmCompanyId,
                    // pmBranchId : relatedUserBranch?.branchId,
                    pmBranchId: buyerReq?.pmBranchId,
                    emailId: relatedSeller?.emailId, 
                    // emailId : "jayanth_vangipuram@procmart.com",
                    billAddrId: relatedUserBranch?.primaryBillAddrId, 
                    docNo : eachSellerReq?.docNo,
                    fileNo : eachSellerReq?.fileNo,
                    isURD: isURD, 
                    createdBy : usersData?.userId, 
                    updatedBy : usersData?.userId}
            })

            const prevSellerReqItems = sellerReqItems?.filter(eachSellerReqItem => !eachSellerReqItem?.isNew)
            const data = {
                sellerReqs : updatedSellerReqData,
                sellerReqItems : updatedSellerReqItems,
                prevSellerReqItems : prevSellerReqItems
            }
            
            const verificationRes = await isUserVerified()
            if(verificationRes.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity: 'error', summary: "Google Verification is needed", detail: verificationRes?.data?.error, life: 3000}))
            }

            if(false){}
            const res = await postBulkSellerReq(data)
            
            if (res.failure){
                dispatch(raiseToast({severity:'error', detail: res.data.error, summary:'Mails for all vendors has not sent.', life: 3000}))
            } else {
                let sellerReqsResponse = []
                let sellerReqItemsResponse = []
                res?.map(eachItem => {
                    sellerReqsResponse.push(eachItem.sellerReq)
                    eachItem.sellerReqItems.map(eachSellerReqItem => {
                        sellerReqItemsResponse.push(eachSellerReqItem)
                    })
                })
                const updatedSellerReqsResponse = sellerReqs.filter(eachSellerReq => !selectedSellerReqs.includes(eachSellerReq.sellerReqId))
                const updatedSellerReqsItemsResponse = sellerReqItems.filter(eachSellerReqItem => !selectedSellerReqs.includes(eachSellerReqItem.sellerReqId))

                setSellerReqs([...updatedSellerReqsResponse,...sellerReqsResponse])
                setSellerReqItems([...updatedSellerReqsItemsResponse, ...sellerReqItemsResponse])
                dispatch(raiseToast({severity:'success', detail:'Mails has been sent to Vendors.', life: 3000}))
                getSellerReq()
            }
        }
        setIsLoading(false)
    }

    const handleSendMail = async(emailObj, sellerReqId, updatedSellerReqs, updatedSellerReqItems, updatedSellerDetails) => {
        let sellerReq = {}
        let relatedSellerReqItems = []
        let relatedSeller = {}

        if(!updatedSellerReqs){
            sellerReq = sellerReqs.find(eachSellerReq => eachSellerReq.sellerReqId === sellerReqId)
        }else{
            sellerReq = updatedSellerReqs.find(eachSellerReq => eachSellerReq.sellerReqId === sellerReqId)
        }

        if(!updatedSellerReqItems){
            relatedSellerReqItems = sellerReqItems.filter(eachSellerReqItem => (eachSellerReqItem.sellerReqId === sellerReqId))
        }else{
            relatedSellerReqItems = updatedSellerReqItems.filter(eachSellerReqItem => (eachSellerReqItem.sellerReqId === sellerReqId))
        }

        if(!updatedSellerDetails){
            relatedSeller = sellerDetails?.find(eachSeller => eachSeller.userId === sellerReq.userId)
        }else{
            relatedSeller = updatedSellerDetails?.find(eachSeller => eachSeller.userId === sellerReq.userId)
        }

        const activeRoleId = usersData?.activeRoleId
        const relatedUserBranch = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)

        if (relatedSeller?.branchPaymentTerms){
            sellerReq.paymentTerms = relatedSeller?.branchPaymentTerms
        }else {
            sellerReq.paymentTerms = relatedSeller?.companyPaymentTerms
        }

        const isURD = relatedSeller?.gstinCode ? false : true
        let updatedSellerReqItemsData = relatedSellerReqItems.map(eachSellerReqItem => {
            let relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachSellerReqItem.buyerReqItemId)
            let newSellerReqItem = { 
                ...eachSellerReqItem, 
                qty: relatedBuyerReqItem.qty, 
                pmCompanyId: relatedUserBranch?.pmCompanyId, 
                createdBy: usersData?.userId, 
                updatedBy: usersData?.userId
            }
            if(PMCompanyConfig.defaultHSNCode){
                newSellerReqItem.quotHSNCode = PMCompanyConfig.defaultHSNCode
            }
            return newSellerReqItem
        })
        let prevSellerReqItems = sellerReqItems.filter(eachSellerReqItem => !eachSellerReqItem?.isNew)

        const data = {
            sellerReq: {
                branchId: sellerReq.branchId,
                buyerReqId: parseInt(sellerReq.buyerReqId),
                companyId: sellerReq.companyId,
                paymentTerms: sellerReq.paymentTerms,
                userId: sellerReq.userId,
                isNew: sellerReq.isNew,
                sellerReqId: sellerReq.sellerReqId,
                pmCompanyId: relatedUserBranch.pmCompanyId,
                pmBranchId: buyerReq.pmBranchId,
                docNo: sellerReq.docNo,
                fileNo: sellerReq.fileNo,
                emailId: relatedSeller.emailId,
                isURD: isURD, 
                billAddrId: relatedUserBranch.primaryBillAddrId, 
                createdBy: usersData.userId, 
                updatedBy: usersData.userId
            },
            sellerReqItems: updatedSellerReqItemsData,
            prevSellerReqItems: prevSellerReqItems,
            emailObj: emailObj,
            isPassRequirement
        }

        setIsLoading(true)
        const response = await postSellerReq(data)

        if (response.failure){
            setIsLoading(false)
            let summary = ''
            if (sellerReq?.companyId === sellerReq?.pmCompanyId){
                summary = 'Seller Req is not Inserted.'
            }else{
                summary = 'Mail for the Vendor not sent.'
            }
            dispatch(raiseToast({severity:'error', detail: response.data.error, summary: summary, life: 3000}))
        } else {
            const newSellerReq = response.sellerReq
            let responseSellerReqs = []
            if (!updatedSellerReqs){
                responseSellerReqs = sellerReqs.map(eachSellerReq => {
                    if(newSellerReq?.uniqueId === eachSellerReq.sellerReqId){
                        return {...newSellerReq, disabled: true}
                    }
                    return {...eachSellerReq, disabled: true}
                })
            }else{
                responseSellerReqs = updatedSellerReqs.map(eachSellerReq => {
                    if(newSellerReq?.uniqueId === eachSellerReq.sellerReqId){
                        return {...newSellerReq, disabled: true}
                    }
                    return {...eachSellerReq, disabled: true}
                })
            }

            let filteredSellerReqItems = []
            if (!updatedSellerReqItems){
                filteredSellerReqItems = sellerReqItems.filter(eachSellerReqItem => eachSellerReqItem.sellerReqId !== newSellerReq?.uniqueId)
            }else{
                filteredSellerReqItems = sellerReqItems.filter(eachSellerReqItem => eachSellerReqItem.sellerReqId !== newSellerReq?.uniqueId)
            }

            let newSellerReqItems = response?.sellerReqItems?.map(eachSellerReqItem => {
                return {...eachSellerReqItem, isEditable: false, canEditExpiredAndLogistics: false}
            })
            const responseSellerReqItems = [...filteredSellerReqItems, ...newSellerReqItems]
            
            let detail = ''
            if (newSellerReq?.companyId === newSellerReq?.pmCompanyId){
                detail = 'Use From Stock Seller Req is created Successfully.'
            }else{
                detail = 'Mail has Sent Successfully'
            }

            const emailRestrictedPMBranchIds = [3]
            if(emailRestrictedPMBranchIds.includes(buyerReq.pmBranchId)){
                detail = 'Seller Req created successfully.'
            }

            setSellerReqs(responseSellerReqs)
            setSellerReqItems(responseSellerReqItems)
            setInitialSellerReqs(responseSellerReqs)
            setInitialSellerReqItems(responseSellerReqItems)
            dispatch(raiseToast({severity:'success', detail: detail, life: 3000}))
        }
        setIsLoading(false)
    }

    const handleCheckBoxClick = (e) => {
        const sellerReqIds = sellerReqs.map(eachSellerReq => {
            if (eachSellerReq?.isNew){
                return eachSellerReq?.sellerReqId
            }else{
                const isNewSellerReqItemPresent = sellerReqItems?.some(eachSellerReqItem => eachSellerReqItem?.sellerReqId === eachSellerReq?.sellerReqId && eachSellerReqItem?.isNew)
                if (isNewSellerReqItemPresent){
                    return eachSellerReq?.sellerReqId
                }
            }
        })
        if (e.checked){
            setSelectedSellerReqs(sellerReqIds)
        } else {
            setSelectedSellerReqs([])
        }
    }

    const handleSelectSellerReq = (sellerReqId) => {
        if (selectedSellerReqs.includes(sellerReqId)) {
            setSelectedSellerReqs(prev => prev.filter(id => id !== sellerReqId));
        } else {
            setSelectedSellerReqs(prev => [...prev, sellerReqId]);
        }
        const allEditableSelected = sellerReqs
            .filter(eachSellerReq => eachSellerReq.editable === true)
            .every(req => selectedSellerReqs.includes(req.sellerReqId));
    
        setSelectAll(allEditableSelected);
    }

    const handleSelectAllChange = (e) => {
        const checked = e.target.checked
        if (checked) {    
            // const allEditableSellerReqsIds = editableSellerReqs?.map(each=>each?.sellerReqId)
            setSelectedSellerReqs(editableSellerReqIds)
        } else {
            setSelectedSellerReqs([])
        }
    }

    const constructUseStockSellerReqItem = (sellerReq, buyerReqItem, sellerDetails) => {
        const relatedWarehouse = stockWarehouses.find(eachStockWarehouse => eachStockWarehouse.materialId === sellerDetails.materialId && eachStockWarehouse.warehouseId === sellerDetails.warehouseId)

        let quotQty = relatedWarehouse.smartStock > buyerReqItem.qty ? buyerReqItem.qty : relatedWarehouse.smartStock
        const { unitPrice, GSTRate } = calculateStockGSTAndPrice(quotQty, relatedWarehouse?.smartStockMoves)

        let quotTotalAmountBeforeTax = parseFloat(quotQty) * unitPrice
        let totalTax = parseFloat(quotTotalAmountBeforeTax * GSTRate * 0.01)
        let quotTotalAmountWithTax = quotTotalAmountBeforeTax + totalTax

        const relatedHSNSuggestion = hsnSuggestions.find(eachHSNSuggestion => eachHSNSuggestion.originalMaterialId === buyerReqItem.materialId)

        const newSellerReqItem = {
            sellerReqItemId: uuid(),
            sellerReqId: sellerReq.sellerReqId,
            buyerReqId: sellerReq.buyerReqId,
            buyerReqItemId: buyerReqItem.buyerReqItemId,
            materialId: buyerReqItem.materialId,
            shipAddrId: relatedWarehouse.shipAddrId,
            showLogistics: false,
            statusId: 1,
            quotQty: quotQty,
            quotListPrice: unitPrice,
            quotDiscountRate: 0,
            quotUnitPrice: unitPrice,
            quotHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
            quotTotalAmountBeforeTax: quotTotalAmountBeforeTax,
            quotGSTRate: GSTRate,
            quotTotalAmountWithTax: quotTotalAmountWithTax,
            quotLeadTime: 0,
            quotLogisticsBeforeTax: 0,
            quotLogisticsGSTRate: 0,
            quotLogisticsWithTax: 0,
            isNew: true,
            isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true,
            suggestedHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
        }

        return newSellerReqItem
    }

    const handleOnAddSeller = (id, sellerData) => {
        const relatedSeller = sellerData.find(eachSeller => eachSeller.id === id)
        if(relatedSeller){
            const existingSellerReq = sellerReqs?.find(eachSellerReq => eachSellerReq.userId === relatedSeller.userId && eachSellerReq.branchId === relatedSeller.branchId && eachSellerReq.companyId === relatedSeller.companyId)
            if(existingSellerReq){
                let unexistedSellerReqItems = []
                selectedBuyerReqItems?.map(eachSelectedBuyerReqItem => {
                    const relatedBuyerReqItem = buyerReqItems?.find(eachBuyerReqItem => eachBuyerReqItem?.buyerReqItemId === eachSelectedBuyerReqItem)
                    const relatedHSNSuggestion = hsnSuggestions.find(eachHSNSuggestion => eachHSNSuggestion.originalMaterialId === relatedBuyerReqItem.materialId)
                    let newSellerReqItem = null
                    if(relatedSeller.companyId === relatedSeller.pmCompanyId){
                        const recomSellers = sellerData.filter(eachSelSugg => eachSelSugg.userId === relatedSeller.userId)
                        const originalMaterialIds = recomSellers.map(eachRecomSel => eachRecomSel.originalMaterialId)

                        if(originalMaterialIds.includes(relatedBuyerReqItem.materialId)){
                            newSellerReqItem = constructUseStockSellerReqItem(existingSellerReq, relatedBuyerReqItem, relatedSeller)
                        }
                    }
                    else {
                        newSellerReqItem = {
                            sellerReqItemId: uuid(),
                            sellerReqId: existingSellerReq.sellerReqId,
                            buyerReqId: parseInt(existingSellerReq.buyerReqId),
                            buyerReqItemId: relatedBuyerReqItem.buyerReqItemId,
                            materialId: relatedBuyerReqItem.materialId,
                            docNo: existingSellerReq.docNo,
                            fileNo: existingSellerReq.fileNo,
                            shipAddrId: relatedBuyerReqItem.delAddrId,
                            showLogistics: false,
                            statusId: 1,
                            quotQty: 0,
                            quotListPrice: 0,
                            quotDiscountRate: 0,
                            quotUnitPrice: 0,
                            quotHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                            quotTotalAmountBeforeTax: 0,
                            //quotGSTRate: relatedSeller?.gstinCode ? 0 : 0,
                            quotTotalAmountWithTax: 0,
                            quotLeadTime: 0,
                            quotLogisticsBeforeTax: 0,
                            quotLogisticsGSTRate: 0,
                            quotLogisticsWithTax: 0,
                            qty: relatedBuyerReqItem?.qty,
                            isNew: true,
                            isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true,
                            suggestedHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                        }
                    }

                    if(newSellerReqItem){
                    const isSellerReqItemExists = sellerReqItems.some(eachSellerReqItem => (eachSellerReqItem.buyerReqItemId === newSellerReqItem.buyerReqItemId && eachSellerReqItem.sellerReqId === newSellerReqItem.sellerReqId))
                    if (!isSellerReqItemExists){
                        // const updatedSellerReqItems = [...sellerReqItems, newSellerReqItem]
                        unexistedSellerReqItems.push(newSellerReqItem)
                        // setSellerReqItems(updatedSellerReqItems)
                        // setInitialSellerReqItems(updatedSellerReqItems)
                    }else{
                        dispatch(raiseToast({severity:'warn', detail: `Seller already added for this item with materialId ${newSellerReqItem?.materialId}`, life: 3000}))
                    }
                    }
                })
                setSellerReqItems(prevState => [...prevState, ...unexistedSellerReqItems])
                setInitialSellerReqItems(prevState => [...prevState, ...unexistedSellerReqItems])
            } else {
                const newSellerReq = {
                    sellerReqId: uuid(),
                    userId: relatedSeller.userId,
                    buyerReqId : parseInt(buyerReqId),
                    fileNo : buyerReq.fileNo,
                    docNo: buyerReq.docNo,
                    companyId: relatedSeller.companyId,
                    branchId: relatedSeller.branchId,
                    isNew: true,
                    disabled : true
                }
                const updatedSellerReqs = [...sellerReqs, newSellerReq]
                let updatedSellerReqItems = [...sellerReqItems]
                selectedBuyerReqItems?.map(eachSelectedBuyerReqItem => {
                    const relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === eachSelectedBuyerReqItem)
                    const relatedHSNSuggestion = hsnSuggestions.find(eachHSNSuggestion => eachHSNSuggestion.originalMaterialId === relatedBuyerReqItem.materialId)
                    let newSellerReqItem = null
                    if(relatedSeller.companyId === relatedSeller.pmCompanyId){
                        const recomSellers = sellerData.filter(eachSelSugg => eachSelSugg.userId === relatedSeller.userId)
                        const originalMaterialIds = recomSellers.map(eachRecomSel => eachRecomSel.originalMaterialId)

                        if(originalMaterialIds.includes(relatedBuyerReqItem.materialId)){
                            newSellerReqItem = constructUseStockSellerReqItem(newSellerReq, relatedBuyerReqItem, relatedSeller)
                        }
                    }
                    else{                    
                    newSellerReqItem = {
                        sellerReqItemId: uuid(),
                        sellerReqId: newSellerReq.sellerReqId,
                        buyerReqId : parseInt(newSellerReq.buyerReqId),
                        buyerReqItemId: relatedBuyerReqItem.buyerReqItemId,
                        materialId: relatedBuyerReqItem.materialId,
                        shipAddrId : relatedBuyerReqItem.delAddrId,
                        showLogistics : false,
                        statusId: 1,
                        quotQty: 0,
                        quotListPrice: 0,
                        quotDiscountRate: 0,
                        quotUnitPrice: 0,
                        quotHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                        quotTotalAmountBeforeTax: 0,
                        //quotGSTRate: relatedSeller?.gstinCode ? 0 : 0,
                        quotTotalAmountWithTax: 0,
                        quotLeadTime: 0,
                        quotLogisticsBeforeTax: 0,
                        quotLogisticsGSTRate: 0,
                        quotLogisticsWithTax: 0,
                        qty: relatedBuyerReqItem?.qty,
                        isNew : true,
                        isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true,
                        suggestedHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                    }
                    }
                    if(newSellerReqItem){
                        updatedSellerReqItems.push(newSellerReqItem)
                    }
                })
                setSellerReqItems(updatedSellerReqItems)
                setSellerReqs(updatedSellerReqs)
                setInitialSellerReqs(updatedSellerReqs)
                setInitialSellerReqItems(updatedSellerReqItems)
            }

            const existingSellerDetails = sellerDetails.find(eachSellerDetail => eachSellerDetail.userId === relatedSeller.userId && eachSellerDetail.branchId === relatedSeller.branchId && eachSellerDetail.companyId === relatedSeller.companyId)
            if(!existingSellerDetails){
                const updatedSellerDetails = [...sellerDetails, relatedSeller]
                setSellerDetails(updatedSellerDetails)
            }
        }
	}

    const handleOnAddStock = (stockWarehouseId, stockData) => {
        const relatedWarehouse = stockData?.find(eachStock => eachStock.stockWarehouseId === stockWarehouseId)

        if (relatedWarehouse){
            const existingSellerReq = sellerReqs?.find(eachSellerReq => eachSellerReq?.userId === relatedWarehouse?.warehouseManagerId)
            const existingSellerDetails = sellerDetails.find(eachSellerDetail => eachSellerDetail.userId === relatedWarehouse?.warehouseManagerId)
            let updatedSellerDetails = []
            if(!existingSellerDetails){
                updatedSellerDetails = [...sellerDetails, {...relatedWarehouse, userId: relatedWarehouse?.warehouseManagerId, businessTypeId: 6, name : relatedWarehouse?.firstName + " "+ relatedWarehouse?.lastName}]
                setSellerDetails(updatedSellerDetails)
            }else{
                updatedSellerDetails = sellerDetails
            }

            if(existingSellerReq){
                const relatedBuyerReqItem = buyerReqItems?.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === selectedItemId)
                let quotQty = relatedWarehouse?.smartStock > relatedBuyerReqItem?.qty ? relatedBuyerReqItem?.qty : relatedWarehouse?.smartStock

                const { unitPrice, GSTRate } = calculateStockGSTAndPrice(quotQty, relatedWarehouse?.smartStockMoves)

                let quotTotalAmountBeforeTax = parseFloat(quotQty) * unitPrice
                let totalTax = parseFloat(quotTotalAmountBeforeTax * GSTRate * 0.01)
                let quotTotalAmountWithTax = quotTotalAmountBeforeTax + totalTax

                const relatedHSNSuggestion = hsnSuggestions.find(eachHSNSuggestion => eachHSNSuggestion.originalMaterialId === relatedBuyerReqItem.materialId)
                
                const newSellerReqItem = {
                    sellerReqItemId: uuid(),
                    sellerReqId: existingSellerReq.sellerReqId,
                    buyerReqId : parseInt(existingSellerReq.buyerReqId),
                    buyerReqItemId: relatedBuyerReqItem.buyerReqItemId,
                    materialId: relatedBuyerReqItem.materialId,
                    docNo: existingSellerReq.docNo,
                    fileNo: existingSellerReq.fileNo,
                    shipAddrId : relatedBuyerReqItem.delAddrId,
                    showLogistics: false,
                    statusId: 1,
                    quotQty: quotQty,
                    quotListPrice: unitPrice,
                    quotDiscountRate: 0,
                    quotUnitPrice: unitPrice,
                    quotHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                    quotTotalAmountBeforeTax: quotTotalAmountBeforeTax,
                    quotGSTRate: GSTRate,
                    quotTotalAmountWithTax: quotTotalAmountWithTax,
                    quotLeadTime: 0,
                    quotLogisticsBeforeTax: 0,
                    quotLogisticsGSTRate: 0,
                    quotLogisticsWithTax: 0,
                    isNew : true,
                    isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true,
                    suggestedHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                }
                const isSellerReqItemExists = sellerReqItems.some(eachSellerReqItem => (eachSellerReqItem.buyerReqItemId === newSellerReqItem.buyerReqItemId && eachSellerReqItem.sellerReqId === newSellerReqItem.sellerReqId))
                let updatedSellerReqItems
                if (window.confirm("Are you sure you want to continue...?")){
                    if (!isSellerReqItemExists){
                        updatedSellerReqItems = [...sellerReqItems, newSellerReqItem]
                        setSellerReqItems(updatedSellerReqItems)
                    }else{
                        return dispatch(raiseToast({severity:'warn', detail: `Seller already added for this item with materialId ${newSellerReqItem?.materialId}`, life: 3000}))
                    }
                    let emailObj = {}
                    handleSendMail(emailObj, existingSellerReq?.sellerReqId, sellerReqs, updatedSellerReqItems, updatedSellerDetails)
                }
            } else {
                const newSellerReq = {
                    sellerReqId: uuid(),
                    userId: relatedWarehouse?.warehouseManagerId,
                    buyerReqId : parseInt(buyerReqId),
                    fileNo : buyerReq.fileNo,
                    docNo: buyerReq.docNo,
                    companyId: relatedWarehouse?.companyId,
                    branchId: relatedWarehouse?.branchId,
                    isNew: true
                }
                const updatedSellerReqs = [...sellerReqs, newSellerReq]
                
                const relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === selectedItemId)
                let quotQty = relatedWarehouse?.smartStock > relatedBuyerReqItem?.qty ? relatedBuyerReqItem?.qty : relatedWarehouse?.smartStock

                const { unitPrice, GSTRate } = calculateStockGSTAndPrice(quotQty, relatedWarehouse?.smartStockMoves)

                let quotTotalAmountBeforeTax = parseFloat(quotQty) * unitPrice
                let totalTax = parseFloat(quotTotalAmountBeforeTax * GSTRate * 0.01)
                let quotTotalAmountWithTax = quotTotalAmountBeforeTax + totalTax

                const relatedHSNSuggestion = hsnSuggestions.find(eachHSNSuggestion => eachHSNSuggestion.originalMaterialId === relatedBuyerReqItem.materialId)

                const newSellerReqItem = {
                    sellerReqItemId: uuid(),
                    sellerReqId: newSellerReq.sellerReqId,
                    buyerReqId : parseInt(newSellerReq.buyerReqId),
                    buyerReqItemId: relatedBuyerReqItem.buyerReqItemId,
                    materialId: relatedBuyerReqItem.materialId,
                    shipAddrId : relatedBuyerReqItem.delAddrId,
                    showLogistics : false,
                    statusId: 1,
                    quotQty: quotQty,
                    quotListPrice: unitPrice,
                    quotDiscountRate: 0,
                    quotUnitPrice: unitPrice,
                    quotHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null,
                    quotTotalAmountBeforeTax: quotTotalAmountBeforeTax,
                    quotGSTRate: GSTRate,
                    quotTotalAmountWithTax: quotTotalAmountWithTax,
                    quotLeadTime: 0,
                    quotLogisticsBeforeTax: 0,
                    quotLogisticsGSTRate: 0,
                    quotLogisticsWithTax: 0,
                    isNew : true,
                    isHSNEditable: PMCompanyConfig.HSNEntryAllowed ? false : true,
                    suggestedHSNCode: relatedHSNSuggestion ? relatedHSNSuggestion.HSNCode : null
                }
                const updatedSellerReqItems = [...sellerReqItems, newSellerReqItem]
                if (window.confirm("Are you sure you want to continue...?")){
                    setSellerReqItems(updatedSellerReqItems)
                    setSellerReqs(updatedSellerReqs)
                    let emailObj = {}
                    handleSendMail(emailObj, newSellerReq?.sellerReqId, updatedSellerReqs, updatedSellerReqItems, updatedSellerDetails)
                }
            }
        }
	}

    const handleIncrementSeller = (buyerReqItemId) => {
        setSelectedBuyerReqItems([buyerReqItemId])
        const relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === buyerReqItemId)
        const relatedSellerSuggestions = allSellerSuggestions.filter(eachSelSugg => relatedBuyerReqItem.materialId === eachSelSugg.originalMaterialId)
        setSellerSuggestions(relatedSellerSuggestions)
        setVisibleAssignSeller(true)
    }

    const handleAddClick = async (buyerReqItemId) => {       
        const relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === buyerReqItemId)
        const relatedMandatoryMaterialUseStock = materialMandatoryUseFromStock.find(eachMandatoryMaterial => eachMandatoryMaterial.materialId === relatedBuyerReqItem.materialId)

        let isMaterialMandatoryAvailableWithStock = false
        if(relatedMandatoryMaterialUseStock){
            const relatedStockWarehouses = stockWarehouses.filter(eachStockWarehouse => eachStockWarehouse.materialId === relatedBuyerReqItem.materialId)

            let totalQty = 0
            relatedStockWarehouses.forEach(eachStockWarehouse => {
                totalQty += parseFloat(eachStockWarehouse.smartStock)
            })

            if(relatedBuyerReqItem.qty <= totalQty){
                isMaterialMandatoryAvailableWithStock = true
            }
        }

        if (isMaterialMandatoryAvailableWithStock){
            confirmDialog({
                message: 'Approval will be required as you are proceeding with different seller for mandatory use stock material(s)',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => handleIncrementSeller(buyerReqItemId)
            })
        }else {
            handleIncrementSeller(buyerReqItemId)
        }
    }

    const handleDiscardClick = (sellerReqId) => {
        let updatedSellerReqItems = sellerReqItems
        if (window.confirm("Do you want to discard the changes?")){
            updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                let relatedSellerReqItem = eachSellerReqItem
                if (eachSellerReqItem?.sellerReqId === sellerReqId){
                    relatedSellerReqItem = initialSellerReqItems?.find(eachInitialSellerReqItem => eachInitialSellerReqItem?.sellerReqItemId === eachSellerReqItem?.sellerReqItemId)
                    if (relatedSellerReqItem?.quotQty !== eachSellerReqItem?.quotQty || (relatedSellerReqItem?.quotQty === 0 && relatedSellerReqItem?.statusId === 1)){
                        return {...relatedSellerReqItem, isEditable: false, canEditExpiredAndLogistics: false}
                    }else{
                        return {...relatedSellerReqItem, isEditable: false, canEditExpiredAndLogistics: false}
                    }
                }
                return relatedSellerReqItem
            })
            setSellerReqItems(updatedSellerReqItems)
            let updatedSellerReqs = sellerReqs?.map(eachSellerReq => {
                if (eachSellerReq?.sellerReqId === sellerReqId){
                    return JSON.parse(JSON.stringify({...eachSellerReq, disabled: true}))
                }
                return eachSellerReq
            })
            setSellerReqs(updatedSellerReqs)
            setInitialSellerReqs(updatedSellerReqs)
        }else{
            updatedSellerReqItems = sellerReqItems?.map(eachSellerReqItem => {
                let relatedSellerReqItem = eachSellerReqItem
                if (eachSellerReqItem?.sellerReqId === sellerReqId){
                    relatedSellerReqItem = initialSellerReqItems?.find(eachInitialSellerReqItem => eachInitialSellerReqItem?.sellerReqItemId === eachSellerReqItem?.sellerReqItemId)
                    if ((relatedSellerReqItem?.quotQty !== eachSellerReqItem?.quotQty || (relatedSellerReqItem?.quotQty === 0 && relatedSellerReqItem?.statusId === 1))){
                        return {...eachSellerReqItem, isEditable: true, canEditExpiredAndLogistics: true}
                    }else{
                        return {...eachSellerReqItem, isEditable: false, canEditExpiredAndLogistics: true}
                    }
                    // return {...relatedSellerReqItem, isEditable: true, canEditExpiredAndLogistics: true}
                }
                return eachSellerReqItem
            })
            setSellerReqItems(updatedSellerReqItems)
            let updatedSellerReqs = sellerReqs?.map(eachSellerReq => {
                if (eachSellerReq?.sellerReqId === sellerReqId){
                    return {...eachSellerReq, disabled: false}
                }
                return eachSellerReq
            })
            setSellerReqs(updatedSellerReqs)
            setInitialSellerReqs(updatedSellerReqs)
        }
       
    }

    const handleToggler = (sellerReqItemId, name, value) => {
        const updatedSellerReqItems = sellerReqItems.map(eachSellerReqItem => {
            if (eachSellerReqItem.sellerReqItemId === sellerReqItemId){
                return {...eachSellerReqItem, [name] : value }
            } 
            return eachSellerReqItem
        })
        setSellerReqItems([...updatedSellerReqItems])
    }

    const handleOnDeleteClick = (buyerReqItemId, userId) => {
        const relatedSellerReq = sellerReqs?.find(eachSellerReq => eachSellerReq?.userId === userId)
        const relatedSellerReqItems = sellerReqItems?.filter(eachSellerReqItem => eachSellerReqItem?.sellerReqId === relatedSellerReq?.sellerReqId)
        let updatedSellerReqItems = sellerReqItems.filter(eachSellerReqItem => {
            if (eachSellerReqItem.sellerReqId === relatedSellerReq?.sellerReqId && eachSellerReqItem.isNew){
                if (eachSellerReqItem.buyerReqItemId === buyerReqItemId){
                    return false
                }
            } 
            return true
        })
        if (relatedSellerReq?.isNew){
            let updatedSellerReqs = sellerReqs?.filter(eachSellerReq => eachSellerReq?.sellerReqId !== relatedSellerReq?.sellerReqId)
            if (relatedSellerReqItems.length > 1){
                setSellerReqItems(updatedSellerReqItems)
            }
            else {
                setSellerReqs(updatedSellerReqs)
                setSellerReqItems(updatedSellerReqItems)
            }
            dispatch(raiseToast({severity:'success', detail:'Seller has been Deleted', life: 3000}))
        }else{
            const isNewSellerReqItem = relatedSellerReqItems?.find(eachSellerReqItem => {
                if (eachSellerReqItem?.isNew && eachSellerReqItem?.buyerReqItemId === buyerReqItemId){
                    return true
                }
            })
            const expiredSellerReqItem = relatedSellerReqItems?.find(eachSellerReqItem => {
                if (eachSellerReqItem?.buyerReqItemId === buyerReqItemId && !eachSellerReqItem?.isNew){
                    return true
                }
            })
            if (!expiredSellerReqItem){
                if (isNewSellerReqItem?.isNew){
                    const updatedSellerReqItems = sellerReqItems?.filter(eachSellerReqItem => eachSellerReqItem?.sellerReqItemId !== isNewSellerReqItem?.sellerReqItemId)
                    setSellerReqItems(updatedSellerReqItems)
                    dispatch(raiseToast({severity:'success', detail:'Seller has been Deleted', life: 3000}))
                }else{
                    dispatch(raiseToast({severity:'warn', detail:'Seller Cannot be Deleted', life: 3000}))
                }
            }else{
                dispatch(raiseToast({severity:'warn', detail:'Seller Cannot be deleted because seller has previous quote for same requirement item.', life: 3000}))
            }
        }
    }

    const handleSellerQuoteChange = (data) => {
        const {sellerReqItemId, e} = data
        let {name, value} = e.target

        const updatedSellerReqItems = sellerReqItems.map(eachSellerReqItem => {
            const relatedSellerReq = sellerReqs?.find(eachSellerReq => eachSellerReq?.sellerReqId === eachSellerReqItem?.sellerReqId)
            const relatedSeller = sellerDetails.find(eachSeller => eachSeller.userId === relatedSellerReq.userId)
            const relatedVendorRateContractItem = vendorRateContractItems.find(eachSellerReqItem => eachSellerReqItem.vendorRateContractId === relatedSellerReq.vendorRateContractId)
            if (eachSellerReqItem.sellerReqItemId === sellerReqItemId){
                if(value.length > 1 && value[0] === "0"){
                    value = value.substring(1)
                }else if (value === ""){
                    if (name === "quotHSNCode"){
                        value = null
                    }else{
                        value = 0
                    }
                }

                if (name === "quotHSNCode"){
                    if(eachSellerReqItem[name] && value && relatedSellerReq.companyId !== relatedSellerReq.pmCompanyId && (String(eachSellerReqItem[name]).length > value.length)){
                        return {...eachSellerReqItem, [name]: null, quotGSTRate: (!relatedSeller.gstinCode || relatedSeller.gstinCode === "URD") ? "0" : null}
                    }

                    if(relatedSellerReq.companyId !== relatedSellerReq.pmCompanyId && value !== eachSellerReqItem.quotHSNCode){
                        return {...eachSellerReqItem, [name]: value, quotGSTRate: (!relatedSeller.gstinCode || relatedSeller.gstinCode === "URD") ? "0" : null}
                    }

                    return {...eachSellerReqItem, [name]: value, quotGSTRate: (!relatedSeller.gstinCode || relatedSeller.gstinCode === "URD") ? "0" : null}
                }
                else if (name === "quotUnitPrice"){
                    if (eachSellerReqItem?.quotListPrice > 0 && value < eachSellerReqItem?.quotListPrice && !data.vrcDiscoundCond){
                        const relatedQuotDiscountRate = ((eachSellerReqItem?.quotListPrice - value)/eachSellerReqItem?.quotListPrice) * 100
                        return {...eachSellerReqItem, [name] : value, "quotDiscountRate" : (round(relatedQuotDiscountRate, 2))}
                    }else{
                        if (eachSellerReqItem.quotDiscountRate < 100){
                            let relatedQuotListPrice = round(value /(1 - eachSellerReqItem?.quotDiscountRate * 0.01))
                            return {...eachSellerReqItem, [name]: value, "quotListPrice": relatedQuotListPrice}
                        }else {
                            return {...eachSellerReqItem, [name]: value, "quotListPrice": value, "quotDiscountRate": 0}   
                        }
                    }
                }
                else if (name === "quotDiscountRate"){
                    if(value >= 100){
                        dispatch(raiseToast({severity:'error', detail:'Discount cant be entered more than 100'}))
                        return eachSellerReqItem
                    }
                    if (eachSellerReqItem?.quotListPrice){
                        if (relatedSellerReq?.companyId === relatedSellerReq?.pmCompanyId || data.vrcUnitPriceCond){
                            let relatedQuotListPrice = round(eachSellerReqItem?.quotUnitPrice /(1 - value * 0.01))
                            return {...eachSellerReqItem, [name] : value, "quotListPrice" : (round(relatedQuotListPrice, 2))}
                        }else{
                            const relatedQuoteUnitPrice = round((eachSellerReqItem?.quotListPrice - (eachSellerReqItem?.quotListPrice * value * 0.01)), 2)
                            return {...eachSellerReqItem, [name] : value, "quotUnitPrice" : round(relatedQuoteUnitPrice, 2)}
                        }
                    }else{
                        let relatedQuotListPrice = round(eachSellerReqItem?.quotUnitPrice /(1 - value * 0.01))
                        return {...eachSellerReqItem, [name]: value, "quotListPrice": relatedQuotListPrice}
                    }
                }
                else if (name === "quotListPrice"){
                    if (value === 0){
                        if (relatedSellerReq?.companyId === relatedSellerReq?.pmCompanyId){
                            return {...eachSellerReqItem, [name] : eachSellerReqItem?.quotUnitPrice, "quotDiscountRate" : 0}
                        }
                        else if(data.vrcUnitPriceCond){
                            const relatedQuotDiscountRate = ((value - eachSellerReqItem?.quotUnitPrice)/value) * 100
                            return {...eachSellerReqItem, [name] : value, "quotDiscountRate" : (round(relatedQuotDiscountRate, 2))}
                        }
                        else if(!data.vrcDiscoundCond){
                            return {...eachSellerReqItem, [name] : value, "quotUnitPrice" : 0}
                        }
                    }else{
                        if (relatedSellerReq?.companyId === relatedSellerReq?.pmCompanyId || data.vrcUnitPriceCond){
                            const relatedQuotDiscountRate = ((value - eachSellerReqItem?.quotUnitPrice)/value) * 100
                            return {...eachSellerReqItem, [name] : value, "quotDiscountRate" : (round(relatedQuotDiscountRate, 2))}
                        }else{
                            let relatedUnitPrice = value - value * eachSellerReqItem?.quotDiscountRate * 0.01
                            return {...eachSellerReqItem, [name] : value, "quotUnitPrice": round(relatedUnitPrice)}
                        }
                    }
                }else if (name === "quotLeadTime"){
                    if (data.vrcLeadTimeCond && relatedVendorRateContractItem && value > relatedVendorRateContractItem.leadTime){
                        dispatch(raiseToast({severity:'error', detail:'Lead Time cannot be increased for Vendor RC Item.'}))
                        return {...eachSellerReqItem, [name]: relatedVendorRateContractItem.leadTime}
                    }
                    return {...eachSellerReqItem, [name]: value}
                }
                return {...eachSellerReqItem, [name] : value}
            }
            return eachSellerReqItem
        })
       
        setSellerReqItems([...updatedSellerReqItems])
    }

    const handleSellerReqDocs = (sellerReqId, name, value) => {
        const updatedSellerReqs = sellerReqs.map(eachSellerReq => {
            if (eachSellerReq.sellerReqId === sellerReqId){
                let newSellerReq = {...eachSellerReq, [name] : value}
                return newSellerReq
            } else {
                return eachSellerReq
            }
        })
        setSellerReqs(updatedSellerReqs)
    }

    const handleDeleteSellerReqDocs = (sellerReqId, docString) => {
        const updatedSellerReqs = sellerReqs.map(eachSellerReq => {
            if (eachSellerReq.sellerReqId === sellerReqId){
                const docProof = eachSellerReq.docProof.filter(eachDoc => eachDoc !== docString)
                return {...eachSellerReq, docProof : docProof}
            } else {
                return eachSellerReq
            }
        })
        setSellerReqs(updatedSellerReqs)
    }

    const handleAssignSeller = async () => {
        const selectedMaterialIds = selectedBuyerReqItems.map(eachBuyReqItemId => {
            const relatedBuyerReqItem = buyerReqItems.find(eachReqItem => eachReqItem.buyerReqItemId === eachBuyReqItemId)
            return relatedBuyerReqItem.materialId
        })

        const mandatoryMaterialWithAvailableStock = selectedMaterialIds.find(eachMaterialId => {
            const relatedMaterialMandatoryUseFromStock = materialMandatoryUseFromStock.find(eachMandatoryMaterial => eachMandatoryMaterial.materialId === eachMaterialId)
            if(relatedMaterialMandatoryUseFromStock){
                const relatedStockWarehouses = stockWarehouses.filter(eachStockWarehouse => eachStockWarehouse.materialId === eachMaterialId)
                const relatedBuyerReqItem = buyerReqItems.find(eachReqItem => eachReqItem.materialId === eachMaterialId)

                let totalQty = 0
                relatedStockWarehouses.forEach(eachStockWarehouse => {
                    totalQty += parseFloat(eachStockWarehouse.smartStock)
                })

                if(relatedBuyerReqItem.qty <= totalQty){
                    return true
                }
                else{
                    return false
                }
            }

            return false
        })

        // if(mandatoryMaterialWithAvailableStock){
        //     return dispatch(raiseToast({severity:'warn', detail:`Can't assign sellers for Material ${mandatoryMaterialWithAvailableStock}. It is mandatory to use this material from stock!`, life: 3000}))
        // }

        if (selectedBuyerReqItems?.length === 1){
            handleAddClick(selectedBuyerReqItems[0])

        }
        else if(selectedBuyerReqItems?.length > 1){
            if (mandatoryMaterialWithAvailableStock){
                confirmDialog({
                    message: 'Approval will be required as you are proceeding with different seller for mandatory use stock material(s)',
                    header: 'Confirmation',
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => { 
                        const relatedSellerSuggestions = allSellerSuggestions.filter(eachSelSugg => selectedMaterialIds.includes(eachSelSugg.originalMaterialId))
                        setSellerSuggestions(relatedSellerSuggestions)
                        setVisibleAssignSeller(true)
                    }
                })
            }else {
                const relatedSellerSuggestions = allSellerSuggestions.filter(eachSelSugg => selectedMaterialIds.includes(eachSelSugg.originalMaterialId))
                setSellerSuggestions(relatedSellerSuggestions)
                setVisibleAssignSeller(true)
            }
        }
        else{
            dispatch(raiseToast({severity:'warn', detail:'Select Requirement Items.', life: 3000}))
        }
    }

    const handleSelectAllBuyerReqItems = (e) => {
        const buyerReqItemIds = buyerReqItems?.map(eachBuyerReqItem => eachBuyerReqItem?.buyerReqItemId)
        if (e.checked){
            setSelectedBuyerReqItems(buyerReqItemIds)
        } else {
            setSelectedBuyerReqItems([])
        }
    }

    const handleSelectReqItem = (buyerReqItemId) => {
        if(selectedBuyerReqItems.includes(buyerReqItemId)){
            const updatedBuyerReqItems = selectedBuyerReqItems.filter(eachBuyerReqItemId => eachBuyerReqItemId !== buyerReqItemId)
            setSelectedBuyerReqItems(updatedBuyerReqItems)
        } else {
            const updatedBuyerReqItems = [...selectedBuyerReqItems, buyerReqItemId]
            setSelectedBuyerReqItems(updatedBuyerReqItems)
        }
    }

    const handleOnHide = () => {
        setSellerSuggestions([])
        setVisibleAssignSeller(false)
        setSelectedBuyerReqItems([])
    }
    const buyerName = getFullName(buyerDetails?.firstName, buyerDetails?.lastName)

    const handleLeadTimeChange = (e) => {
        setGlobalLeadTime(e.target.value)
    }

    const handleGlobalLeadTime = () => {
        if(globalLeadTime){
            let anyItemUpdated = false
            const updatedItems = sellerReqItems.map(item => {
                if (selectedSellerReqs.includes(item.sellerReqId)) {
                    if(item?.isEditable){
                        anyItemUpdated = true
                        return { ...item, quotLeadTime: globalLeadTime }
                    }
                }
                return item
            })
            if (anyItemUpdated) {
                setSellerReqItems(updatedItems)
                setSelectedSellerReqs([])
                dispatch(raiseToast({ severity: 'success', detail: 'Lead Time applied', life: 1000 }))
            } else {
                dispatch(raiseToast({ severity: 'error', summary: 'Error!', detail: 'No editable material found to apply.', life: 2000 }));
            }
        }
        else{
            dispatch(raiseToast({severity:'error', detail:'Please enter lead time', life: 2000}))
        }

    }

    const handleGlobalHSNCode = () => {
        if (!globalHSNCode) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter HSN', life: 2000 }))
        }

        const relatedHSNCodes = HSNMasterData.filter(eachCode => eachCode.HSNCode === parseInt(globalHSNCode))
        if (relatedHSNCodes.length === 0) {
            return dispatch(raiseToast({ severity: 'error', detail: "Invalid HSN" }))
        }

        let itemUpdated = false
        const updatedItems = sellerReqItems.map(item => {
            if (selectedSellerReqs.includes(item.sellerReqId)) {
                if (item.isEditable) {
                    itemUpdated = true

                    if(item.quotGSTRate){
                        const relatedGSTRates = relatedHSNCodes.map(eachHSN => eachHSN.GSTRate)
                        if(!relatedGSTRates.includes(item.quotGSTRate)){
                            return { ...item, quotHSNCode: globalHSNCode, quotGSTRate: null }
                        }
                    }
                    return { ...item, quotHSNCode: globalHSNCode }
                }
            }
            return item
        })
        if (itemUpdated) {
            setSellerReqItems(updatedItems)
            setSelectedSellerReqs([])
            dispatch(raiseToast({ severity: 'success', detail: 'HSN applied', life: 1000 }))
        }
    }

    const handleGlobalGSTRate = () => {
        if (!globalGSTRate) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter GST rate', life: 2000 }))
        }

        let itemUpdated = false
        const updatedItems = sellerReqItems.map(item => {
            if (selectedSellerReqs.includes(item.sellerReqId)) {
                if (item.isEditable) {
                    if(item.quotHSNCode){
                        const relatedHSNCodes = HSNMasterData.filter(eachCode => eachCode.HSNCode === parseInt(item.quotHSNCode))
                        const relatedGSTRates = relatedHSNCodes.map(eachHSN => eachHSN.GSTRate)
                        if(relatedGSTRates.includes(parseInt(item.quotGSTRate))){
                            itemUpdated = true
                            return { ...item, quotGSTRate: globalGSTRate }
                        }
                        return { ...item, quotGSTRate: null }
                    }
                    else{
                        return { ...item, quotGSTRate: null }
                    }
                }
            }
            return item
        })
        if (itemUpdated) {
            setSellerReqItems(updatedItems)
            setSelectedSellerReqs([])
            dispatch(raiseToast({ severity: 'success', detail: 'GST Rate applied', life: 1000 }))
        }
    }

    const renderSellerRequisitionSkeleton = () => {
        return(
            <div>
                <SellerRequisitionSkeleton/>
            </div>
        )
    }

    if(isInitialLoading){
        return renderSellerRequisitionSkeleton()
    }

    let gstRates = PMCompanyConfig.GSTRates
    let gstOptions = []
    gstRates.map(eachGSTRate => gstOptions.push({label: eachGSTRate.toString(), GSTRate: eachGSTRate}))

    return (
        <div className="send-requisition-layout">
            <div className="flex flex-row align-items-center">
                <h4 className="mx-2 my-1">Buyer Req No - {buyerReq.docNo}</h4>
                { 
                    buyerReq?.docNo ? <CopyToClipboard text={buyerReq.docNo} /> : ""
                }
                {isStarRFQ && (
                    <>
                        <p className={`star m-0 ml-2 custom-tooltip-${buyerReq.docNo}`} style={{height: "39px", fontSize: "30px", color: hasNullDocProof ? "red" : "green" }}>&#9733;</p>
                        <Tooltip target={`.custom-tooltip-${buyerReq.docNo}`} position="top" autoHide>
                            {hasNullDocProof 
                                ? "This is a star RFQ! Doc proof is required for all sellers where a quote has been entered."
                                : "This is a star RFQ! All required document proofs are uploaded successfully."
                            }
                        </Tooltip>
                    </>
                )}
                <p className="m-0">
                    <span className="ml-5 " style={{fontWeight:"bold"}}> Buyer:  </span> {buyerDetails?.companyName} - {buyerName}
                </p> 
            </div>

            <div className="p-card mt-2 product-comp-p-card">
                <div className="flex mb-1" style={{width: "100%", flex:1, justifyContent:"space-between"}}>
                    <div className="ml-1 select-all-req-items"> 
                        <Checkbox inputId="selectAllReqItems" className="" checked={selectedBuyerReqItems.length > 0 && buyerReqItems.length === selectedBuyerReqItems.length} onChange={(e)=> handleSelectAllBuyerReqItems(e)}/>
                        <label htmlFor="selectAllReqItems" className="ml-2">Select All Req Items</label>
                    </div>
                    <div className="mr-2 mb-1">
                        <Button className="small-btn" label="Assign Sellers" onClick={() => handleAssignSeller()} disabled={buyerReq.reqTagId === 4 && buyerReq.orderTypeId !== 3} tooltip={buyerReq.reqTagId === 4 && buyerReq.orderTypeId !== 3 ? 'VMI products should be used from stock only!' : ''} tooltipOptions={{ position: 'top', showOnDisabled: true, }} permissions={[189]} />
                    </div>
                </div>
                {
                    buyerReqItems?.map(eachReq => {
                        const relatedSellerReqItems = sellerReqItems?.filter(eachSellerReqItem => eachSellerReqItem?.buyerReqItemId === eachReq?.buyerReqItemId)
                        const relatedSellerReqIds = relatedSellerReqItems?.map(eachSellerReqItem => eachSellerReqItem?.sellerReqId)
                        const relatedSellerReqs = sellerReqs?.filter(eachSellerReq => relatedSellerReqIds.includes(eachSellerReq?.sellerReqId))
                        const relatedSellerIds = relatedSellerReqs?.map(eachSellerReq => eachSellerReq?.userId)
                        const relatedMaterials = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachReq?.materialId)
                        let relatedSellerDetails = sellerDetails?.filter(eachSellerDetail => relatedSellerIds.includes(eachSellerDetail?.userId))

                        relatedSellerDetails = relatedSellerDetails.map(eachSeller => {
                            if (eachSeller.businessTypeId === null && eachSeller?.companyId !== eachSeller.pmCompanyId){
                                eachSeller.businessTypeId = 5
                            }
                            if (eachSeller.companyId === eachSeller.pmCompanyId){
                                eachSeller.businessTypeId = 6
                            }
                            let relatedBusinessType = companyBusinessTypes?.find(eachBusinessType => eachBusinessType?.businessTypeId === eachSeller?.businessTypeId)
                            return {...eachSeller, ...relatedBusinessType}
                        })

                        return (
                            <ProductComponent 
                                key={`buyerReqItem-${eachReq.buyerReqItemId}`} 
                                setSelectedItemId={setSelectedItemId} 
                                selectedBuyerReqItems={selectedBuyerReqItems}
                                handleOnAddStock={handleOnAddStock}
                                materialData={relatedMaterials} 
                                materialBrands={materialBrandsData} 
                                materialCategories={materialCategoriesData} 
                                sellerReqs={relatedSellerReqs} 
                                deliveryAddressData={deliveryAddressData} 
                                deliveryAddressList={deliveryAddressList} 
                                companyBusinessTypes={companyBusinessTypes} 
                                sellerReqItems={relatedSellerReqItems} 
                                stockWarehouses={stockWarehouses}
                                buyerReqItem={eachReq} 
                                buyerReq={buyerReq}
                                sellersData={relatedSellerDetails} 
                                buyerReqItemId={eachReq.buyerReqItemId} 
                                handleOnDeleteClick={handleOnDeleteClick} 
                                handleAddClick={handleAddClick} 
                                handleDeliveryAddressChange={handleDeliveryAddressChange} 
                                handleSelectReqItem={handleSelectReqItem}
                                vendorRateContractItems={vendorRateContractItems}
                            />
                    )})
                }
                <Loading visible={isLoading}/> 
            </div>
            <h5 className="mt-3 ml-2 mb -2">Send Requisition and Quotations</h5>
            <div className="p-card vendor-comp-p-card">
                {sellerReqs?.length > 0 && 
                    <div className='p-card flex flex-row justify-content-start'>
                        <div className="flex flex-column mr-5">
                            <label className="mt-2" style={{ marginBottom: "5px", fontSize: "12px" }}>Select All</label>
                            <Checkbox
                                checked={selectedSellerReqs?.length > 0 && selectedSellerReqs?.length === editableSellerReqIds?.length}
                                style={{ textAlign: "center" }}
                                onChange={handleSelectAllChange}
                            />
                        </div>
                        <div className="flex flex-column col-12 md:col-4 lg:col-2 lg:mb-0 w-6rem">
                            <TextInputField name="leadTime" labelText="Lead Time" value={globalLeadTime} onChange={handleLeadTimeChange} keyfilter="pnum" />
                        </div>
                        <div className="flex flex-column lg:mb-0 md:col-4 lg:col-2 mt-3 w-6rem">
                            <Button label="APPLY" style={{ backgroundColor: "#26a69a", height: "32px" }} onClick={handleGlobalLeadTime} disabled={!selectedSellerReqs?.length > 0} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4 lg:col-2 lg:mb-0 w-6rem">
                            <TextInputField name="HSNCode" labelText="HSN" value={globalHSNCode} onChange={(e) => setGlobalHSNCode(e.target.value)} keyfilter="pnum" />
                        </div>
                        <div className="flex flex-column lg:mb-0 md:col-4 lg:col-2 mt-3 w-6rem">
                            <Button label="APPLY" style={{ backgroundColor: "#26a69a", height: "32px" }} onClick={handleGlobalHSNCode} disabled={!selectedSellerReqs?.length > 0} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4 lg:col-2 lg:mb-0 w-6rem">
                            {/* <TextInputField name="globalGSTRate" labelText="GST Rate" value={globalGSTRate} onChange={(e) => setGlobalGSTRate(e.target.value)} keyfilter="pnum" /> */}
                            <DropDownField name="globalGSTRate" labelText={PMCompanyConfig.GSTRateLabel} value={globalGSTRate} options={gstOptions} optionLabel="label" optionValue="GSTRate" onChange={(e) => setGlobalGSTRate(e.target.value)}/>

                        </div>
                        <div className="flex flex-column lg:mb-0 md:col-4 lg:col-2 mt-3 w-6rem">
                            <Button label="APPLY" style={{ backgroundColor: "#26a69a", height: "32px" }} onClick={handleGlobalGSTRate} disabled={!selectedSellerReqs?.length > 0} />
                        </div>
                    </div>
                }
                {
                    sellerReqs?.map(eachSellerReq => (
                        <VendorComponent 
                            key={`sellerReq-${eachSellerReq.sellerReqId}`}
                            HSNMasterData={HSNMasterData} 
                            materialDetails={materialDetails} 
                            setSellerReqs={setSellerReqs}
                            setSellerReqItems={setSellerReqItems} 
                            userDetails={usersData?.userNameDetails} 
                            sellers={sellerDetails} 
                            initialSellerReqItems={initialSellerReqItems} 
                            setInitialSellerReqs={setInitialSellerReqs}
                            setInitialSellerReqItems={setInitialSellerReqItems}
                            sellerReqsData={sellerReqs}
                            sellerReq={eachSellerReq} 
                            selectedSellerReqs={selectedSellerReqs} 
                            getSellerReq={getSellerReq} 
                            handleExpiryClick={handleExpiryClick} 
                            handleSelectSellerReq={handleSelectSellerReq} 
                            handleSellerReqDocs={handleSellerReqDocs} 
                            handleDeleteSellerReqDocs={handleDeleteSellerReqDocs} 
                            handleDiscardClick={handleDiscardClick} 
                            handleCheckBoxClick={handleCheckBoxClick} 
                            sellerReqItems={sellerReqItems} 
                            handleSendMail={handleSendMail} 
                            handleToggler={handleToggler}
                            handleSellerQuoteChange={handleSellerQuoteChange} 
                            buyerReqItems={buyerReqItems}
                            deliveryAddressList={deliveryAddressList}
                            buyerDetails={buyerDetails}
                            buyerReq={buyerReq}
                            materialMandatoryUseFromStock={materialMandatoryUseFromStock}
                            companyWarehousesData={companyWarehousesData}
                            PMBranches={PMBranches}
                            sellerReqs={sellerReqs}
                            isStarRFQ={isStarRFQ}
                            vendorRateContractItems={vendorRateContractItems}
                            PMCompanyConfig={PMCompanyConfig}
                            pastSellerPOMaterialTransactions={pastSellerPOMaterialTransactions}
                            isPrevSelPOMaterialTransactionsLoading={isPrevSelPOMaterialTransactionsLoading}
                            isPassRequirement={isPassRequirement}
                            buyerBranchUsers={buyerBranchUsers}
                            companyCreditPeriods={companyCreditPeriods}
                        />
                    ))
                }
            </div>
            <SellerSearch 
                header = "Assign Seller" 
                visible={visibleAssignSeller} 
                isSellerRecomendationsLoading={isSellerRecomendationsLoading} 
                sellerSuggestions={sellerSuggestions} 
                onHide={handleOnHide} 
                handleOnAddSeller={handleOnAddSeller}
                isRecommendedSellersNeeded={isRecommendedSellersNeeded}
                companyBusinessTypes={companyBusinessTypes}
                stockWarehouses={stockWarehouses}
                buyerReq={buyerReq}
            />
        </div>
    )
}

export default SendRequisition;